import Thumbnails from "./Thumbnails";
import Cards from "./Cards";
import Filters from "./Filters";
import Totals from "./Totals";
import Slideshow from "./Slideshow";

export default {
  Thumbnails,
  Cards,
  Filters,
  Totals,
  Slideshow
};
